import {ElementRef} from '@angular/core';

import * as XLSX_ from 'xlsx';

import * as moment_ from 'moment';

import {HtmlTags} from '../enums';

const moment = moment_;
const XLSX = XLSX_;

const ReportDateFormat = 'MM/DD/YY';
const ReportDateTimeFormat = 'MM/DD/YY HH:mm:ss';

export class XlsxHelper {
    static generateXlsxDataForContainer(container: ElementRef, labels: string[]): Array<Array<any>> {
        const data = [labels];

        container.nativeElement.querySelectorAll(HtmlTags.Tr).forEach((tr: HTMLTableRowElement) => {
            const reportDataRows = [];

            tr.querySelectorAll(HtmlTags.Td).forEach((td: HTMLTableCellElement) => {
                reportDataRows.push(td.innerText);
            });

            if (reportDataRows.length > 0) {
                data.push(reportDataRows);
            }
        });

        return data;
    }

    static generateXlsxByGivenData(fileName: string, data: Array<Array<any>>, nonFormattingColumnIds: number[] = []): void {
        const workSheet = XLSX.utils.aoa_to_sheet(data);
        const workBook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workBook, workSheet, 'sheet');

        XlsxHelper.formatCells(workSheet, nonFormattingColumnIds);

        XLSX.writeFile(workBook, fileName + '.xlsx');
    }

    static formatCells(workSheet: any, nonFormattingColumnIds: number[]): void {
        const range = XLSX.utils.decode_range(workSheet['!ref']);

        for (let cellRowIndex = range.s.r; cellRowIndex <= range.e.r; ++cellRowIndex) {
            for (let cellColumnIndex = range.s.c; cellColumnIndex <= range.e.c; ++cellColumnIndex) {
                if (!nonFormattingColumnIds.includes(cellColumnIndex)) {
                    const cell = workSheet[XLSX.utils.encode_cell({r: cellRowIndex, c: cellColumnIndex})];

                    if (cell && cell.v) {
                        XlsxHelper.formatNumberCells(cell);
                    }
                }
            }
        }
    }

    static formatNumberCells(cell: any): void {
        let strippedValue = cell.v
            .trim()
            .replace(/,/g, '');

        const minusMatch = strippedValue.match('^[\(]');

        if (minusMatch) {
            strippedValue = strippedValue
                .replace(/\(/, '')
                .replace(/\)/, '');

            strippedValue = `-${strippedValue}`;
        }

        const dateFormatCheck = moment(cell.v.toString(), ReportDateFormat, true);
        const dateTimeFormatCheck = moment(cell.v.toString(), ReportDateTimeFormat, true);

        /**
         * Skipping all date types, due to
         * escape additional localization of the dates
         */

        const integerRegex = new RegExp(/^-?\d+$/);
        const floatNumberRegex = new RegExp(/^-?\d+\.\d+$/);
        const percentageRegex = new RegExp(/^(-?\d+\s?%)|(-?\d+\.\d+\s?%)$/);
        const isInteger = integerRegex.test(strippedValue);

        if (!dateFormatCheck.isValid() && !dateTimeFormatCheck.isValid()) {
            if (isInteger || floatNumberRegex.test(strippedValue)) {
                const format = !isInteger ? '#,##0.00####;[Red]( #,##0.00#### )' : '#,##0;[Red]( #,##0 )';

                cell.t = 'n';
                cell.z = format;
                cell.w = undefined;
                cell.v = !isInteger ? parseFloat(strippedValue) : parseInt(strippedValue, 10);
            } else if (percentageRegex.test(strippedValue)) {
                strippedValue = strippedValue.toString()
                    .replace('%', '')
                    .trim();

                cell.t = 'n';
                cell.z = '0.00####"%";[Red]( 0.00####"%" )';
                cell.w = undefined;
                cell.v = parseFloat(strippedValue);
            }
        }
    }

    static generateXlsxForContainerWithId(
        container: ElementRef,
        labels: string[],
        fileName: string,
        nonFormattingColumnIds: number[] = []
    ): void {
        const fileData = [];

        container.nativeElement.childNodes.forEach((node: HTMLDivElement, nodeIndex: number) => {
            if (node.id) {
                if (nodeIndex > 0) {
                    fileData.push([]);
                }

                const date = moment(node.id);
                const id = !date.isValid() ? node.id : date.format(ReportDateFormat);

                fileData.push([id], [], labels);

                node.querySelectorAll(HtmlTags.Tr).forEach((tr: HTMLTableRowElement) => {
                    const reportDataRows = [];

                    tr.querySelectorAll(HtmlTags.Td).forEach((td: HTMLTableCellElement) => {
                        reportDataRows.push(td.innerText);
                    });

                    if (reportDataRows.length > 0) {
                        fileData.push(reportDataRows);
                    }
                });
            }
        });

        const workSheet = XLSX.utils.aoa_to_sheet(fileData);
        const workBook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workBook, workSheet, 'sheet');

        XlsxHelper.formatCells(workSheet, nonFormattingColumnIds);

        XLSX.writeFile(workBook, fileName + '.xlsx');
    }
}
